export enum Locales {
  English = 'en',
  Japanese = 'ja',
  Deutsch = 'de',
  Netherlands = 'nl',
}
